export default __webpack_public_path__ + "static/media/mobile_home_delete_icon.4644ffa8.svg";